import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Spin, Row, Col, Input, message } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import TabsBlockProFile from '../../../../components/user/TabsBlockProFile'
import { datasetsPersonalInformation, tabProfile } from '../../../../config/datasetsEmployeeRegistration'
import { checkType } from '../../../../utils/checkType'
import { pushAge, pushAgeDate } from '../../../../utils/formatdate'

const { TabPane } = Tabs
const { Text, Title } = Typography

const newsDataProfile = '';

class Rights extends Component {
	state = {
		detailProfile : [],
		dataNewProfile : {},
		loaddingDataNews : false,
		dataFetch: [],
		preLoad: false
		// fetchProfile: []
	}

	fetchEmployeeFamily = async () =>{
		const { client, location } = this.props
		this.setState({
			preLoad:true
		})
		try{
			
			const { data, errors } = await client.query({
				query: Queries.fetchEmployeeRights,
			})
			
			if(data){
				this.setState({
					dataFetch:data,
					preLoad:false
				})
			}
			
		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// message.error("Token is expired.")
		}
	}

	checkBenefits = (value) =>{
		if(value){
			if (value === 'ไม่ได้รับสิทธิ์') {
				return value
			} else if (value === 0 || value === "0") {
				return 'ไม่ได้รับสิทธิ์'
			} else if (value === 1 || value === "1") {
				return 'ได้รับสิทธิ์'
			} else {
				return value
			}
		}else {
			return 'ไม่ได้รับสิทธิ์'
		}
	}

	checkPersonStatusDate = (value) =>{
		if(value.personStatus == 'ถึงแก่กรรม'){
			return value.deathDate ? pushAgeDate(value.birthDate, value.deathDate) : ''
		}else{
			return value.birthDate ? pushAge(value.birthDate) : ''
		}
	}
	
	async componentDidMount(){
		const newsDataProfile = '';
		const { history, location, match, staticContext } = this.props
		const { detailProfile } = this.state
		await this.fetchEmployeeFamily()
		// await this.newDataProfile()
	}

	render() {
		const { history, location, match, staticContext } = this.props
		const { dataFetch, preLoad } = this.state
		return (
			<Container match={match}>
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						<Tabs type="card" style={{borderBottom:"6px solid #d7222a"}} className="my-4">
							<TabPane tab={'สิทธิรักษาพยาบาล'} key={0} className="mb-0">
								{
									dataFetch.length !== 0 &&
										<>
											{
												dataFetch.fetchEmployeeFamily.length !== 0 &&
												<>
													{ dataFetch.fetchEmployeeFamily.map((value,keys) =>
														<Row gutter={16}>
															{
																console.log(value.relationshipText,' : '+value.benefits)
															}
															<Col xs={24} md={24} className="mb-2">
																<strong className="color-red">
																	{ value.relationshipText }
																</strong>
															</Col>
															<Col xs={24} sm={12} className="mb-3">
																<div className="">
																	<Text>
																		ชื่อ-นามสกุล
																	</Text><br></br>
																	<Input value={value.firstName+' '+value.lastName} disabled={true}/>
																</div>
															</Col>
															<Col xs={24} sm={12} className="mb-3">
																<div className="">
																	<Text>
																		เลขบัตรประชาชน
																	</Text><br></br>
																	<Input value={value.identityCard} disabled={true}/>
																</div>
															</Col>
															<Col xs={24} sm={12} className="mb-3">
																<div className="">
																	<Text>
																		สถานะสิทธิรักษาพยาบาล 
																	</Text><br></br>
																	<Input 
																		className={ value.benefits ? '' : 'font-italic' } 
																		value={ this.checkBenefits(value.benefits) } 
																		disabled={true}
																	/>
																</div>
															</Col>
															<Col xs={24} sm={12} className="mb-3">
																<div className="">
																	<Text>
																		เลข HN โรงพยาบาลจุฬาลงกรณ์
																	</Text><br></br>
																	<Input 
																		value={ value.hnNo ? value.hnNo : 'ไม่พบข้อมูล' } 
																		className={ value.hnNo ? '' : 'font-italic' } 
																		disabled={true}
																	/>
																</div>
															</Col>
															<Col xs={24} sm={12} className="mb-3">
																<div className="">
																	<Text>
																		เลข HN โรงพยาบาลสมเด็จพระบรมราชเทวี ณ ศรีราชา
																	</Text><br></br>
																	<Input 
																		value={ value ? value.hnNo_Somdej ? value.hnNo_Somdej : 'ไม่พบข้อมูล' : 'ไม่พบข้อมูล' } 
																		className={ value ? value.hnNo_Somdej ? '' : 'font-italic'  : 'font-italic' } 
																		disabled={true}
																	/>
																</div>
															</Col>
															<Col xs={24} sm={12} className="mb-3">
																<div className="">
																	<Text>
																		วันเกิด
																	</Text><br></br>
																	<Input 
																		value={ value.birthDate ? checkType(value.birthDate) : 'ไม่พบข้อมูล' } 
																		className={ value.birthDate ? '' : 'font-italic' } 
																		disabled={true}
																	/>
																</div>
															</Col>
															<Col xs={24} sm={12} className="mb-3">
																<div className="">
																	<Text>
																		เพศ
																	</Text><br></br>
																	<Input value={checkType(value.gender)} disabled={true}/>
																</div>
															</Col>
															<Col xs={24} sm={12} className="mb-3">
																<div className="">
																	<Text>
																		อายุ
																	</Text><br></br>
																	<Input
																		value={ this.checkPersonStatusDate(value) ?  this.checkPersonStatusDate(value) : 'ไม่พบข้อมูล' } 
																		className={ this.checkPersonStatusDate(value) ? '' : 'font-italic' } 
																		disabled={true}
																	/>
																</div>
															</Col>
															<Col xs={24} sm={12} className="mb-3">
																<div className="">
																	<Text>
																	สถานภาพ
																	</Text><br></br>
																	<Input 
																		className={ value.personStatus ? '' : 'font-italic' } 
																		value={ value ? value.personStatus ? value.personStatus : 'ไม่พบข้อมูล' : 'ไม่พบข้อมูล' } 
																		disabled={true}
																	/>
																</div>
															</Col>
														</Row>
													)}
												</>
												||
												<Col xs={24} sm={24} align="center">
													<Text>
														ไม่พบข้อมูลครอบครัว
													</Text>
												</Col>
											}
										</>
									||
									preLoad &&
									<Col span={24} align="center">
										<Spin />
									</Col>
								}
							</TabPane>
						</Tabs>
					</div>
				</div>
			</Container>
		)
	}
}

Rights.propTypes = {
	//
}

export default withApollo(Rights)
